import React from "react";
import Marquee from "react-fast-marquee";

const BRANDS = [
  { name: "Havells", url: "https://logo.clearbit.com/havells.com" },
  { name: "Legrand", url: "https://logo.clearbit.com/legrand.com" },
  { name: "Anchor", url: "https://logo.clearbit.com/panasonic.com" },
  { name: "Polycab", url: "https://logo.clearbit.com/polycab.com" },
  { name: "Philips", url: "https://logo.clearbit.com/philips.com" },
  { name: "Finolex", url: "https://logo.clearbit.com/finolex.com" },
  { name: "Crompton", url: "https://logo.clearbit.com/crompton.co.in" },
  { name: "Bajaj", url: "https://logo.clearbit.com/bajajelectricals.com" },
  { name: "V-Guard", url: "https://logo.clearbit.com/vguard.in" },
  { name: "Orient", url: "https://logo.clearbit.com/orientelectric.com" },
];

export default function Brands() {
  return (
    <section
      id="brands"
      data-testid="brands-section"
      className="py-16 md:py-24 bg-white border-y border-[#00296B]/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="text-xs uppercase tracking-[0.3em] text-[#334155] font-semibold mb-4">
          — Trusted Partners
        </div>
        <h2
          className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#00296B] leading-tight mm-underline-center"
          data-testid="brands-heading"
        >
          Brands we deal in
        </h2>
        <p className="mt-6 text-base sm:text-lg text-[#334155] max-w-2xl mx-auto">
          Authorised partners of India&apos;s most respected electrical brands —
          delivering authentic, warranty-backed products every time.
        </p>
      </div>

      <div className="mt-14">
        <Marquee
          gradient
          gradientColor="#FFFFFF"
          gradientWidth={100}
          speed={40}
          pauseOnHover
          data-testid="brands-marquee"
        >
          {BRANDS.map((b) => (
            <div
              key={b.name}
              data-testid={`brand-${b.name.toLowerCase()}`}
              className="mx-6 sm:mx-10 flex items-center justify-center h-24 w-40"
              title={b.name}
            >
              <img
                src={b.url}
                alt={`${b.name} logo`}
                className="mm-brand-logo max-h-14 max-w-[140px] object-contain"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  e.currentTarget.parentElement.innerHTML = `<span class="font-display font-bold text-2xl text-[#00296B]">${b.name}</span>`;
                }}
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
